module.exports = __webpack_public_path__ + "img/entry-assistance.2a85b3c4.svg";